import { Alert, BannerAlertType as RadiantBannerAlertType } from '@thoughtspot/radiant-react/widgets/alert';
import React, { useState, useEffect, memo } from 'react';
import { BannerAlertType as SdkBannerAlertType, ChartToTSEvent, } from '@thoughtspot/ts-chart-sdk';
import { translate as t } from '@thoughtspot/i18n';
const SDK_TO_RADIANT_BANNER_TYPE = {
    [SdkBannerAlertType.INFO]: RadiantBannerAlertType.INFO,
    [SdkBannerAlertType.WARNING]: RadiantBannerAlertType.WARNING,
    [SdkBannerAlertType.ERROR]: RadiantBannerAlertType.ERROR,
    [SdkBannerAlertType.SUCCESS]: RadiantBannerAlertType.SUCCESS,
};
const CustomGlobalAlertBannerComponent = ({ onEvent, emitEvent, }) => {
    const [globalBannerAlertConfig, setGlobalBannerAlertConfig] = useState(null);
    const [isGlobalBannerAlertVisible, setIsGlobalBannerAlertVisible,] = useState(false);
    useEffect(() => {
        if (onEvent) {
            onEvent(ChartToTSEvent.ShowGlobalAlertBanner, {
                setIsGlobalBannerAlertVisible,
                setGlobalBannerAlertConfig,
            });
            onEvent(ChartToTSEvent.HideGlobalAlertBanner, {
                setIsGlobalBannerAlertVisible,
            });
        }
    }, [onEvent, emitEvent]);
    if (!isGlobalBannerAlertVisible || !globalBannerAlertConfig) {
        return null;
    }
    const message = globalBannerAlertConfig.labelTranslation
        ? t(globalBannerAlertConfig.labelTranslation)
        : globalBannerAlertConfig.alertMessage;
    const bannerType = globalBannerAlertConfig.type
        ? SDK_TO_RADIANT_BANNER_TYPE[globalBannerAlertConfig.type]
        : RadiantBannerAlertType.WARNING;
    return (React.createElement(Alert.Banner, { message: message, isVisible: isGlobalBannerAlertVisible, type: bannerType, showCloseButton: globalBannerAlertConfig.showCloseButton, onClose: () => {
            setIsGlobalBannerAlertVisible(false);
        } }));
};
export default memo(CustomGlobalAlertBannerComponent);
//# sourceMappingURL=banner.js.map